import React, { useEffect, useState, useRef } from "react"
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import "./ViewPolicy.scss"
import { Toast } from "primereact/toast"
import PolicyApi from "Api/PolicyApi"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"

const ViewPolicy = () => {
  document.title = "View Policy"
  const { id } = useParams()
  const location = useLocation()
  const viewData = location.state?.data || {}
  const navigate = useNavigate()
  const accessToken = localStorage.getItem("accessToken")

  const [policyData, setPolicyData] = useState({
    policyName: "",
    policyDescription: "",
    policyContent: "",
  })
  const [loading, setLoading] = useState(true)
  const toast = useRef(null)

  const getPolicy = () => {
    setLoading(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    PolicyApi.getPolicy(config)
      .then(response => {
        const policies = response.data.data || []
        const policy = policies.find(p => p._id === id) || viewData
        
        if (policy) {
          setPolicyData({
            policyName: policy.policyName || "",
            policyDescription: policy.policyDescription || "",
            policyContent: policy.policyContent || "",
          })
        }
        
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Policy fetched successfully",
            life: 3000,
          })
        }
        setLoading(false)
      })
      .catch(error => {
        console.error("Error fetching policy:", error)
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response?.data?.message || "Failed to fetch policy",
            life: 3000,
          })
        }
        setLoading(false)
      })
  }

  useEffect(() => {
    getPolicy()
  }, [id, accessToken])

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Policy", link: "/Policy" },
    { label: "View Policy", link: "#" },
  ]
  
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <div className="main-content-container">
        <Row>
          <Col xs="12">
            <div className="policy-header d-flex align-items-center justify-content-between">
              <CustomBreadCrumb
                data={breadcrumbItems}
                pageTitle="View Policy"
                handleClick={handleBreadcrumbClick}
              />
              <div className="policy-actions">
                <Button
                  color="primary"
                  onClick={() => navigate(`/editPolicy/${id}`, { state: policyData })}
                  className="me-2"
                >
                  Edit Policy
                </Button>
                <Button
                  color="secondary"
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </div>
            </div>
            <Card className="mt-4">
              <CardBody>
                <div className="policy-view-form">
                  <div className="form-group">
                    <label className="label">Policy Name</label>
                    <div className="policy-value">
                      {policyData.policyName || "No policy name available"}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="label">Policy Description</label>
                    <div className="policy-value">
                      {policyData.policyDescription || "No policy description available"}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="label">Policy Content</label>
                    <div className="policy-content">
                      {policyData.policyContent ? (
                        <div 
                          className="policy-html-content"
                          dangerouslySetInnerHTML={{ __html: policyData.policyContent }}
                        />
                      ) : (
                        <div className="policy-value">No policy content available</div>
                      )}
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default ViewPolicy